var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-areas"},_vm._l((_vm.buttonAreas),function(item){return _c(item.component,{key:item.alias,tag:"component",attrs:{"entity":_vm.entity,"entities":_vm.entities}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }